import BannerSetup from "@commons/banner-settings";
import React from "react";

const StoreBannerSetup = () => {
  return <BannerSetup />;
};

export default StoreBannerSetup;
